import { createAction, props } from '@ngrx/store';
import { FormState } from './formArticle.reducer';

export const loadForm = createAction('[FormArticle] Load FormArticle');

export const saveForm = createAction('[FormArticle] Save FormArticle');

export const updateForm = createAction(
    '[Form] Update FormArticle',
    props<FormState>()
);

